import {Component} from '@angular/core';

@Component({
    selector: 'app-root',
    template: `
        <ion-app class="unselectable">
            <ion-router-outlet></ion-router-outlet>
        </ion-app>
    `,
    standalone: false
})
export class AppComponent {
}
